export default __webpack_public_path__ + "48340d6a5818ab4646f37f2ad0f890bc.svg";